import { ProductInfo } from '../../feature';

const FirstStep: React.FC = () => {
  return (
    <div>
      <ProductInfo />
    </div>
  );
};

export default FirstStep;
